import { createContext, useContext, useEffect, useState } from "react";
import { me } from "../services";

const AuthContext = createContext();
const AuthDispatchContext = createContext();
const AuthUpdateUserInfo = createContext();

export const AuthContextProvider = ({ children }) => {

    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const updateUserInfo = (updates) => {
        setUser(prev => ({
            ...prev,
            userInfo: {
                ...(prev?.userInfo ?? {}),
                ...updates
            }
        }));
    };

    const logout = () => {
        localStorage.removeItem("token");
        setUser(null);
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const isAdminLogin = params.get("admin") === "true";

        // اگر لینک ادمین زده شد، کاربر فعلی logout شود
        if (isAdminLogin) {
            localStorage.removeItem("token");
            setUser(null);
            setIsLoading(false);
            return;
        }

        const token = localStorage.getItem("token");

        if (!token) {
            setIsLoading(false);
            return;
        }

        const loadUser = async () => {
            try {
                const data = await me();
                setUser(data);
            } catch {
                localStorage.removeItem("token");
                setUser(null);
            } finally {
                setIsLoading(false);
            }
        };

        loadUser();
    }, []);



    return (
        <AuthContext.Provider value={{ user, isLoading }}>
            <AuthDispatchContext.Provider value={{ setUser, logout }}>
                <AuthUpdateUserInfo.Provider value={updateUserInfo}>
                    {children}
                </AuthUpdateUserInfo.Provider>
            </AuthDispatchContext.Provider>
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
export const useAuthAction = () => useContext(AuthDispatchContext);
export const useAuthInfo = () => useContext(AuthUpdateUserInfo);
